<template>
  <div class="user-management">
    <template>
      <h4 style="color: aliceblue;margin-top: -30px">
        企业联系人管理
      </h4>
    </template>
    <el-row :gutter="40">
      <el-col :span="24" :xs="24">
        <el-form ref="queryForm" :inline="true" :model="queryParams" label-width="68px" size="small">
          <el-form-item>
            <el-button icon="el-icon-plus" type="primary" @click="handleAdd">新增
            </el-button>

          </el-form-item>
          <el-form-item  prop="coId">
            <el-select v-model="queryParams.coId" filterable clearable placeholder="所属企业">
              <el-option v-for="item in company" :key="item.value" :label="item.lable" :value="parseInt(item.value)" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="queryParams.name" placeholder="联系人姓名" />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="handleQuery">搜索</el-button>
            <!-- <el-button icon="el-icon-refresh" @click="handleReset"
              >重置</el-button
            > -->
          </el-form-item>
        </el-form>

        <el-table v-loading="loading" element-loading-text="数据载入中" element-loading-spinner="el-icon-loading"
          :data="pageList">

          <el-table-column align="center" label="企业名称" prop="coName" />
          <el-table-column align="center" label="联系人1" prop="name" width="80" />
          <el-table-column align="center" label="手机号1" prop="mobile1" width="110" />
          <el-table-column align="center" label="座机号1" prop="tel1" width="110" />
          <el-table-column align="center" label="联系人2" prop="name2" width="80" />
          <el-table-column align="center" label="手机号2" prop="mobile2" width="110" />
          <el-table-column align="center" label="座机号2" prop="tel2" width="110" />
          <el-table-column align="center" label="联系人3" prop="name3" width="80" />
          <el-table-column align="center" label="手机号3" prop="mobile3" width="110" />
          <el-table-column align="center" label="座机号3" prop="tel3" width="110" />
          <el-table-column align="center" label="联系人4" prop="name4" width="80" />
          <el-table-column align="center" label="手机号4" prop="mobile4" width="110" />
          <el-table-column align="center" label="座机号4" prop="tel4" width="110" />
          <el-table-column align="center" label="联系人5" prop="name5" width="80" />
          <el-table-column align="center" label="手机号5" prop="mobile5" width="110" />
          <el-table-column align="center" label="座机号5" prop="tel5" width="110" />
          <!-- <el-table-column align="center" label="手机号2" prop="mobile2" width="200" />
          <el-table-column align="center" label="手机号3" prop="mobile3" width="200" /> -->
          <el-table-column align="center" label="状态" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" style="color: green;"><b>正常</b></span>
              <span v-if="scope.row.status == 0" style="color: red;"><b>停用</b></span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="success" icon="el-icon-edit" size="mini" circle plain
                @click.stop="handleDetail(scope.row)" />
              <el-button type="danger" icon="el-icon-delete" size="mini" circle plain
                @click.stop="handleDelete(scope.row)" />
            </template>
          </el-table-column>
        </el-table>

        <commonPagination :page="pagination" :pageSizes="[10, 20, 30, 40, 50, 100]" :getList="handleQuery">
        </commonPagination>
      </el-col>
    </el-row>
    <!-- 新增或修改参数配置对话框 -->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="1300px">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="所属企业" prop="coId">
              <el-select v-model="form.coId" filterable placeholder="请输入或选择">
                <el-option v-for="item in company" :key="item.value" :label="item.lable" :value="parseInt(item.value)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人1" prop="name">
              <el-input v-model="form.name" placeholder="请输入联系人姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系方式1" prop="mobile1">
              <el-input v-model="form.mobile1" placeholder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="座机号1" prop="tel1">
              <el-input v-model="form.tel1" placeholder="请输入座机号" type="number" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人2" prop="name2">
              <el-input v-model="form.name2" placeholder="请输入联系人姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系方式2" prop="mobile2">
              <el-input v-model="form.mobile2" placeholder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="座机号2" prop="tel2">
              <el-input v-model="form.tel2" placeholder="请输入座机号" type="number" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人3" prop="name3">
              <el-input v-model="form.name3" placeholder="请输入联系人姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系方式3" prop="mobile3">
              <el-input v-model="form.mobile3" placeholder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="座机号3" prop="tel3">
              <el-input v-model="form.tel3" placeholder="请输入座机号" type="number" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人4" prop="name4">
              <el-input v-model="form.name4" placeholder="请输入联系人姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系方式4" prop="mobile4">
              <el-input v-model="form.mobile4" placeholder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="座机号4" prop="tel4">
              <el-input v-model="form.tel4" placeholder="请输入座机号" type="number" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人5" prop="name5">
              <el-input v-model="form.name5" placeholder="请输入联系人姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系方式5" prop="mobile5">
              <el-input v-model="form.mobile5" placeholder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="座机号5" prop="tel5">
              <el-input v-model="form.tel5" placeholder="请输入座机号" type="number" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              <el-input v-model="form.sort" placeholder="" type="number" />
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio-group v-model="form.status">
                  <el-radio :label="1">正常</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">提 交</el-button>
        <el-button @click="dialog.visible = false">取 消</el-button>
      </div>
    </el-dialog>



  </div>
</template>

<script>
  import commonPagination from "@/components/commonPagination.vue";
  export default {
    name: "person-management",
    components: {
      commonPagination
    },
    props: {},
    data() {
      return {
        company:JSON.parse(localStorage.getItem('company')),
        loading: true,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        queryParams: {

        },
        queryParam: {
          pageIndex: 0,
          pageRow: 1000,
        },
        pagination: {
          pageIndex: 1,
          pageRow: 10,
          total: 0
        },
        pageList: [],
        dialog: {
          title: undefined,
          visible: false,
          flag: undefined
        },
        apiUrl: {
          delApi: 'GET_hyContactDelete',
          addApi: 'POST_hyContactAdd',
          updateApi: 'POST_hyContactUpdate',
          indexApi: 'POST_hyContactIndex',
          Enterpriseinfo: 'POST_hyEnterpriseByRole'
        },
        // 表单参数
        form: {
          coId: "",
          coName: "",
          id: 0,
          mobile1: "",
          mobile2: "",
          mobile3: "",
          mobile4: "",
          mobile5: "",
          tel1: "",
          tel2: "",
          tel3: "",
          tel4: "",
          tel5: "",
          name: "",
          name2: "",
          name3: "",
          name4: "",
          name5: "",
          sort: 1,
          status: 1,
        },
        // 表单校验
        rules: {
            coId: [{
              required: true,
              message: "企业不能为空",
              trigger: "blur"
            }],
            name: [{
              required: true,
              message: "姓名不能为空",
              trigger: "blur"
            }],
            mobile1: [{
              required: true,
              pattern: /\d{11}$/,
              message: "请输入正确的手机号码",
              trigger: "blur"
            }],
        }
      };
    },
    methods: {
      async loadData() {
        this.handleQuery();
      },
      handleQuery(obj = {}) {
        if ("pageNo" in obj) {
          this.queryParams.pageIndex = this.pagination.pageIndex = obj.pageNo;
        } else {
          this.queryParams.pageIndex = this.pagination.pageIndex;
        }
        if ("pageSize" in obj) {
          this.queryParams.pageRow = this.pagination.pageRow = obj.pageSize;
        } else {
          this.queryParams.pageRow = this.pagination.pageRow;
        }
        if (this.queryParams.Time != null) {
          this.queryParams.beginTime = this.queryParams.Time[0];
          this.queryParams.endTime = this.queryParams.Time[1];
        }
        this.$http[this.apiUrl.indexApi](this.queryParams).then(response => {
          const {
            data,
            total
          } = response;
          this.pageList = data;
          this.pagination.total = total;
          this.loading = false;
        });
      },
      handleReset() {
        this.pagination = {
          pageIndex: 1,
          pageRow: 10,
          total: 0
        };
        this.queryParams = {

        };
        this.handleQuery();
      },

      handleAdd() {
        this.resetForm();
        this.dialog = {
          title: "新增企业联系人",
          visible: true,
          flag: true
        };

      },
      async handleDetail(row) {
        this.dialog = {
          title: "修改企业联系人",
          visible: true,
          flag: false
        };
        //this.resetForm();
        const data = JSON.parse(JSON.stringify(row));
        this.form = data;
      },

      handleSubmit: function() {
        this.$refs["form"].validate(valid => {
          if (valid) {
            if(this.dialog.flag){
              this.$http.POST_hyContactAdd(this.form).then(res => {
                if (res.code == '00000') {
                  this.$message.success("新增成功");
                  this.dialog.visible = false;
                  this.handleQuery();
                } else {
                  this.$message.error(res.msg);
                }
              });
            }else{
              this.$http.POST_hyContactUpdate(this.form).then(res => {
                if (res.code == '00000') {
                  this.$message.success("修改成功");
                  this.dialog.visible = false;
                  this.handleQuery();
                } else {
                  this.$message.error(res.msg);
                }
              });
            }
          }
        });
      },

      handleDelete(row) {
        const id = row.id;
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http[this.apiUrl.delApi]({
            paramsID: id
          }).then(response => {
            this.$message.success("删除成功");
            this.handleQuery();
          });
        }).catch(() => {});
      },

      // getCompany(){
      //   this.$http[this.apiUrl.Enterpriseinfo](this.queryParam).then(res => {
      //     if(res.data.length>1){
      //       res.data.forEach((element, key) => {
      //         this.company.push({
      //           lable: element.coName,
      //           value: element.id,
      //         });
      //       });
      //     }else{
      //       this.company.push({
      //         lable: res.data.coName,
      //         value: res.data.id,
      //       });
      //     }
      //   });
      // },
      // 表单重置
      resetForm() {
        this.form = {
          coId: "",
          coName: "",
          id: 0,
          mobile1: "",
          mobile2: "",
          mobile3: "",
          mobile4: "",
          mobile5: "",
          name: "",
          name2: "",
          name3: "",
          name4: "",
          name5: "",
          sort: 1,
          status: 1,
        };
        if (this.$refs["form"]) {
          //this.$nextTick(() => {
            this.$refs["form"].resetFields();
          //})
        }
      }
    },
    created() {
      this.loadData();
      this.getCompany();
    },
    watch: {}
  };
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/sysmenu/qylxrgl.vue